import React, { useMemo, useState } from 'react';
import { Placeholder, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { connect } from 'react-redux';

const ContentBlock = ({ heading, intro, testid, params, children }) => {
  let headingHtml;
  if (heading?.value) {
    headingHtml = (
      <header className="vds-content-block__header">
        <Text
          tag="h2"
          className="vds-content-block__primary-title"
          field={heading}
          data-testid={`${testid}-heading`}
        />
      </header>
    );
  }
  const introHtml = (
    <RichText
      tag="div"
      className="vds-content-block__intro vds-content-block__intro--remove-border-bottom"
      field={intro}
      data-testid={`${testid}-content`}
    />
  );

  if (
    params.useContentBlock === undefined ||
    params.useContentBlock === true ||
    params.useContentBlock === 'true'
  ) {
    return (
      <div className={params?.useFormWidth !== 'false' ? 'vds-form-width' : ''}>
        <div
          className={`vds-content-block${
            params?.variant ? ` vds-content-block--${params.variant}` : ''
          }`}
        >
          <div className="vds-content-block__inner">
            {headingHtml}
            {introHtml}
            <div className="vds-content-block__main vds-content-block__main--limited-width">
              {children}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {headingHtml}
      {introHtml}
      {children}
    </>
  );
};

const Accordion = ({ rendering, fields, selectedQuote, setCallback, params }) => {
  const [openItems, setOpenItems] = useState([]);

  const handleOpenItem = itemId => {
    setOpenItems(prevOpenItems => {
      if (prevOpenItems.includes(itemId)) {
        return prevOpenItems.filter(i => i !== itemId);
      }
      if (fields.maxOpenItems?.value && prevOpenItems.length >= fields.maxOpenItems.value) {
        return [...prevOpenItems.slice(1), itemId];
      }
      return [...prevOpenItems, itemId];
    });
  };

  const isSAPPlan = useMemo(() => selectedQuote?.productCode === 'SAP', [selectedQuote]);

  if (isSAPPlan && fields.instanceIndex?.value > 0) {
    return (
      <ContentBlock intro={fields.intro} params={params}>
        <div className="vds-accordion vds-accordion--no-padding">
          <Placeholder
            name="accordion-items"
            rendering={{
              ...rendering,
              placeholders: {
                'accordion-items': [
                  ...(rendering.placeholders['accordion-items'] || []).slice(1, 2),
                ],
              },
            }}
            openItems={openItems}
            handleOpenItem={handleOpenItem}
          />
        </div>
      </ContentBlock>
    );
  }

  return (
    <ContentBlock
      heading={fields.heading}
      intro={fields.intro}
      params={params}
      testid={fields.testid?.value}
    >
      <div className="vds-accordion vds-accordion--no-padding">
        <Placeholder
          name="accordion-items"
          rendering={rendering}
          openItems={openItems}
          handleOpenItem={handleOpenItem}
          setCallback={setCallback}
        />
      </div>
    </ContentBlock>
  );
};

const mapStateToProps = (state, props) => ({
  ...props,
  selectedQuote: state.quoteData.selectedQuote,
});

export default connect(mapStateToProps)(Accordion);
